namespace GeniuzPOS.InitialData {
    export class PsRefundReasonColumns {
        static columnsKey = 'InitialData.PsRefundReason';
    }
}
